<template>
  <v-app id="inspire">
    <div>
      <v-layout class="mb-10">
        <v-flex>
          <h2 class="headline">Open Balance Report</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 mb-0"
          text
          small
          :disabled="loading || loadingCSV || items.length === 0"
          :loading="loadingCSV"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
        >
      </v-layout>
      <v-layout>
        <v-checkbox
          v-model="tableData.hide_zero"
          class="mt-0"
          dense
          :true-value="0"
          :false-value="1"
          label="Show $0 Balances & Credits"
          @change="initialize(1)"
        ></v-checkbox>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <v-layout v-if="
                  (!no_data.includes(item.client_id) &&
                    !no_data.includes(item.client_name)) ||
                  (!no_data.includes(item.commercial_client_id) &&
                    !no_data.includes(item.commercial_client)
                  )"
                  style="margin-left: -14px;">
                  <v-menu offset-y bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        v-if="!no_data.includes(item.client_id)"
                        @click="
                          $router.push(
                            '/client/' + item.client_id + '/show'
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                      <v-list-item
                        v-else
                        @click="
                          $router.push(
                            `/commercial_client/${item.commercial_client_id}/show`
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex v-if="!no_data.includes(item.client_id)">{{ item.client_name }}</v-flex>
                    <v-flex v-else>{{ item.commercial_client }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.client_email)">{{ item.client_email }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.client_address)">{{ item.client_address }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-chip
                  v-if="!no_data.includes(item.client_id)"
                  color="primary"
                  small
                >
                  Residential
                </v-chip>
                <v-chip
                  v-else
                  color="orange darken-4"
                  text-color="white"
                  small
                >
                  Commercial
                </v-chip>
              </td>
              <td>
                <span v-if="!no_data.includes(item.open) && Number(item.open) > 0">${{ parseFloat(item.open).toFixed(2) }}</span>
                <span v-else-if="!no_data.includes(item.credit) && Number(item.credit) > 0">$-{{ parseFloat(item.credit).toFixed(2) }}</span>
                <template v-else>$0.00</template>
              </td>
              <td>
                <span v-if="!no_data.includes(item.overdue)">${{ parseFloat(item.overdue).toFixed(2) }}</span>
                <template v-else>$0.00</template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OpenBalanceReport",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    menu1: false,
    items: [],
    loading: false,
    options: {},
    headers: [
      { text: "Client Name", value: "client_name", sortable: false },
      { text: "Email", value: "client_email", sortable: false },
      { text: "Address", value: "client_address", sortable: false },
      { text: "Type", value: "client_id", sortable: false },
      { text: "Open", value: "open", sortable: false },
      { text: "Overdue", value: "overdue", sortable: false }
    ],
    totalItems: 0,
    search: "",
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      hide_zero: 1,
      dir: "asc"
    },
    loadingCSV: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    if (!this.no_data.includes(this.openBalanaceReportTableData)) {
      this.options = this.openBalanaceReportTableData.options
      this.tableData = this.openBalanaceReportTableData.tableData
    }
    this.initialize();
  },
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.initialize(1);
      }
    }, 1000)
  },
  methods: {
    ...mapActions(["setTableData", "vEmit"]),
    initialize(goTopage) {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      let filtersForSaving = { tableData: _.cloneDeep(this.tableData), options: _.cloneDeep(this.options)}
      filtersForSaving.tableData.draw = 0
      this.setTableData({key: 'openBalanaceReportTableData', value: filtersForSaving})

      ApiService.get("/overdue_credit_all", this.tableData)
        .then(response => {
          let data = response.data;
          this.draw++;
          this.items = data.clients.data;
          this.totalItems = data.clients.total;
          if(goTopage) { this.options.page = goTopage }
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    },
    exportCSV() {
      if(this.no_data.includes(this.dateError)) {
        this.loadingCSV = true

        let body = {
          hide_zero: this.tableData.hide_zero
        }

        ApiService.get("/overdue_credit_all_export", body)
          .then(response => {
            let items = response.data.clients

            let csvContent = ""
            let headers = '"Client Name","Email","Address","Type","Open","Overdue"'
            let csvData = []
            items.forEach(item => {
              let row = {
                client_name: 
                  !this.no_data.includes(item.client_id) &&
                  !this.no_data.includes(item.client_name)
                  ? `"${item.client_name}"`
                  : !this.no_data.includes(item.commercial_client_id) &&
                    !this.no_data.includes(item.commercial_client) ?
                    `"${item.commercial_client}"` :
                    `""`,
                client_email: !this.no_data.includes(item.client_email)
                  ? `"${item.client_email}"`
                  : `""`,
                client_address: !this.no_data.includes(item.client_address)
                  ? `"${item.client_address}"`
                  : `""`,
                type: !this.no_data.includes(item.client_id)
                  ? `"Residential"`
                  : `"Commercial"`,
                open:
                  !this.no_data.includes(item.open) &&
                  Number(item.open) > 0 
                  ? `"${parseFloat(item.open).toFixed(2)}"`
                  : !this.no_data.includes(item.credit) &&
                    Number(item.credit) > 0
                    ? `"-${parseFloat(item.credit).toFixed(2)}"`
                    : `"0.00"`,
                overdue:
                  !this.no_data.includes(item.overdue)
                  ? `"${parseFloat(item.overdue).toFixed(2)}"`
                  : `"0.00"`               
              }
              csvData.push(row)
            });

            csvContent += [
              headers,
              ...csvData.map(item => Object.values(item).join(","))
            ].join("\n").replace(/(^\[)|(\]$)/gm, "")

            const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(data)
            const link = document.createElement("a");
            link.setAttribute("href", url);
            let fileName = `Open Balance Report.csv`
            link.setAttribute(
              "download",
              fileName
            );
            link.click();
            this.loadingCSV = false
          })
          .catch(error => {
            this.vEmit({
              name: "notification", 
              data: {
                status: "error",
                text: "Oops something went wrong..."
              }
            });
            this.loadingCSV = false
          });
      }
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    upperFirst(str) {
      return _.upperFirst(str);
    }
  },
  computed: {
    ...mapGetters(['openBalanaceReportTableData'])
  }
};
</script>
